export default "__VITE_PUBLIC_ASSET__246a4866__"